// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"dynamic-multiple-offers-switch-frequency-lock_modalContent__kg3_I"};